import React, { useRef, useContext } from 'react';
import classnames from 'classnames';
import { isDropdownGroup } from '../../../helpers';
import { useDropdownItems } from '../../../hooks/useDropdownItems';
import StandardMenuOption from '../StandardMenuOption';
import StandardMenuGroup from '../StandardMenuGroup';
import { NavigationDirection, useStandardMenuKeyboardSupport } from '../hooks';
import { itemWithOnSelect } from '../utils';
import StandardMenuContext from '../context';
import { StandardMenuType } from '../types';
import s from './StandardMenuContent.scss';
var StandardMenuContent = function (_a) {
    var id = _a.id, children = _a.children, lightText = _a.lightText, withBottomPaddings = _a.withBottomPaddings, className = _a.className, onSelect = _a.onSelect, items = _a.items, groupClassName = _a.groupClassName, itemClassName = _a.itemClassName, hideCheckIcon = _a.hideCheckIcon, withHoverEffect = _a.withHoverEffect;
    var _b = useContext(StandardMenuContext), menuType = _b.menuType, role = _b.role;
    var filteredItems = useDropdownItems(items).filteredItems;
    var _c = useStandardMenuKeyboardSupport(filteredItems), currentItemIndex = _c.currentItemIndex, navigationDirection = _c.navigationDirection, groupStartingItemIndex = _c.groupStartingItemIndex, handleKeyboardEvents = _c.handleKeyboardEvents, focusNextItem = _c.focusNextItem, focusPreceedingItem = _c.focusPreceedingItem, focusFirstItem = _c.focusFirstItem, focusLastItem = _c.focusLastItem, focusItemByPhrase = _c.focusItemByPhrase, clearFocus = _c.clearFocus;
    var containerRef = useRef(null);
    return (React.createElement("div", { ref: containerRef, id: id, role: role, className: classnames(s['menu'], lightText && s['light-text'], !withBottomPaddings && s['without-bottom-padding'], className), 
        /* TODO: Figure out a way to handle nested groups here
        aria-activedescendant={
          currentItemIndex !== null
            ? `${id}-option-${currentItemIndex}`
            : undefined
        }
        */
        onKeyDown: handleKeyboardEvents, tabIndex: 0, onBlur: function (e) {
            if (containerRef.current &&
                (!e.relatedTarget ||
                    !containerRef.current.contains(e.relatedTarget)) &&
                menuType === StandardMenuType.EMBEDDED) {
                clearFocus();
            }
        }, onFocus: function (e) {
            // DROPDOWN types have their focus managed via which key the dropdown was opened with.
            if (menuType === StandardMenuType.EMBEDDED &&
                e.target === containerRef.current)
                focusFirstItem();
        } },
        filteredItems.map(function (item, idx) {
            return isDropdownGroup(item) ? (React.createElement(StandardMenuGroup, { id: "".concat(id, "-group-").concat(idx), item: item, className: groupClassName, itemClassName: itemClassName, hideCheckIcon: hideCheckIcon, withHoverEffect: withHoverEffect, onPassGroupStart: focusPreceedingItem, onPassGroupEnd: focusNextItem, onPressHome: focusFirstItem, onPressEnd: focusLastItem, onSearch: focusItemByPhrase, 
                // Make sure we start from the bottom of the group if we're traveling up in the list
                startIndexOnFocus: groupStartingItemIndex !== null
                    ? groupStartingItemIndex
                    : navigationDirection === NavigationDirection.UP
                        ? item.items.length - 1
                        : 0, onSelect: onSelect, key: item.label || "item_".concat(idx), focused: idx === currentItemIndex })) : (React.createElement(StandardMenuOption, { id: "".concat(id, "-option-").concat(idx), key: item.value || "item_".concat(idx), item: itemWithOnSelect(item, onSelect), className: itemClassName, hideCheckIcon: hideCheckIcon, withHoverEffect: withHoverEffect, focused: idx === currentItemIndex }));
        }),
        children));
};
StandardMenuContent.displayName = 'StandardMenuContent';
export default StandardMenuContent;
//# sourceMappingURL=StandardMenuContent.js.map